var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionUserPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_user_password"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse",
    opacity: 0.2,
    d: "M46 24C46 36.1503 36.1503 46 24 46C11.8497 46 2 36.1503 2 24C2 11.8497 11.8497 2 24 2C36.1503 2 46 11.8497 46 24Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 18C30.0001 21.3137 27.3139 24 24.0001 24C20.6864 24 18.0001 21.3137 18.0001 18C18.0001 14.6863 20.6864 12 24.0001 12C27.3139 12 30.0001 14.6863 30.0001 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.105 34.7009C12.623 33.3637 15.2466 28 24.0001 28C24.2363 28 24.468 28.0039 24.6954 28.0115C23.0421 29.4771 22.0001 31.6168 22.0001 33.9999V39.8763C18.0875 39.3883 14.6136 37.4877 12.105 34.7009Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0001 30V28C30.0001 24.6863 32.6864 22 36.0001 22C39.3138 22 42.0001 24.6863 42.0001 28L42.0001 30C44.2093 30 46.0001 31.7909 46.0001 34V42C46.0001 44.2091 44.2093 46 42.0001 46H30.0001C27.791 46 26.0001 44.2091 26.0001 42V34C26.0001 31.7909 27.791 30 30.0001 30ZM34.0001 28C34.0001 26.8954 34.8956 26 36.0001 26C37.1047 26 38.0001 26.8954 38.0001 28V30H34.0001V28ZM38.0001 38C38.0001 39.1046 37.1047 40 36.0001 40C34.8956 40 34.0001 39.1046 34.0001 38C34.0001 36.8954 34.8956 36 36.0001 36C37.1047 36 38.0001 36.8954 38.0001 38Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionUserPassword);
export default __webpack_public_path__ + "static/media/ic_action_user_password.58ca40f02583ca87705632decb05165c.svg";
export { ForwardRef as ReactComponent };